<template>
  <div>
    <span style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px" class="has-text-grey">
      {{ setting.label || name }}
      <Tooltip :label="setting.label || name" :content="setting.detail" />
    </span>
    <el-date-picker
      v-model="value[name]"
      type="datetime"
      placeholder="Pick a day"
      style="margin-bottom: 20px"
    >
    </el-date-picker>
  </div>
</template>

<script>
/**
 * DateTime SmartField - Renders a date-time picker for datetime configuration values.
 *
 * @component
 * @description Displays a date-time picker for selecting both date and time.
 * Stores the selected datetime value in the configuration object.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the datetime picker (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Date|string} [setting.default] - Default datetime value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <DateTime
 *   :value="config"
 *   :setting="{ label: 'Scheduled Time', detail: 'Select date and time' }"
 *   name="scheduledTime"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
